<div *ngIf="localService.languageContent && localService.languageContent.common">
  <div class="fact" *ngIf="items">
    <table style="width:100%">
      <tr>
        <td style="width:25%">
          <div class="fact_left">
            <div [ngClass]="isFlashFound ? 'flash_on' : 'flash_off'">
              {{ !isFlashFound ? localService.languageContent.common.fact_header_1 :  localService.languageContent.common.now}}
            </div>
            <div *ngIf="!isFlashFound">
              {{localService.languageContent.common.fact_header_2}}
            </div>
          </div>
        </td>
        <td style="width:75%">
          <div class="fact_right">
            <div>
              {{item}}
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>
